
import { DependencyLifeTime, Injectable } from "@miracledevs/paradigm-web-di";
import { ContextCollection } from "../../../contexts/DependencyContext";
import { WeatherApiClient } from "../clients/WeatherApiClient";
import { IWeatherData } from "./models/IWeatherData";
import { IGetWeatherParameters } from "./models/IGetWeatherParameters";

@Injectable({ collection: ContextCollection, lifeTime: DependencyLifeTime.Singleton })
export class WeatherDataService
{
	private readonly url: string;

	constructor(private readonly apiClient: WeatherApiClient)
    {
        this.url = "weatherdata";
    }

    async getForComponent(parameters: IGetWeatherParameters): Promise<IWeatherData>
    {
        return await this.apiClient.post<IWeatherData>(`${this.url}/component`,{},JSON.stringify(parameters));
    }

    async addInParallel(weatherData: IWeatherData[]): Promise<void>
    {
        this.apiClient.post(`${this.url}/add/parallel`,{},JSON.stringify(weatherData));
    }
}
